import React from "react";
import AntdTreeSelect, { TreeSelectProps } from "antd/lib/tree-select";
import {withError} from '@fishx/tracker';

const TreeNode = AntdTreeSelect.TreeNode;
const SHOW_ALL = AntdTreeSelect.SHOW_ALL;
const SHOW_PARENT = AntdTreeSelect.SHOW_PARENT;
const SHOW_CHILD = AntdTreeSelect.SHOW_CHILD;

type TreeNodeValue = string | number | string[] | number[];

interface FTSProps extends TreeSelectProps<TreeNodeValue> {
  forwardedRef?: any;
}
interface FCProps extends React.FC<FTSProps> {
    TreeNode: typeof TreeNode;
    SHOW_ALL: typeof SHOW_ALL;
    SHOW_PARENT: typeof SHOW_PARENT;
    SHOW_CHILD: typeof SHOW_CHILD;
}

export const TreeSelect: FCProps = (props) => {
  const { forwardedRef, ...rest } = props;
  return (
    <AntdTreeSelect ref={forwardedRef} {...rest} />
  );
};

TreeSelect.TreeNode = TreeNode;
TreeSelect.SHOW_ALL = SHOW_ALL;
TreeSelect.SHOW_PARENT = SHOW_PARENT;
TreeSelect.SHOW_CHILD = SHOW_CHILD;
TreeSelect.displayName = 'TreeSelect';
export default withError(TreeSelect, { forwardRef: true }) ;



// WEBPACK FOOTER //
// ./src/components/tree-select/index.tsx